import React,{useState,useEffect,useRef,useContext} from 'react';
import { Container,Col,Row,Form } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import '../../pages/Dashboard/dashboard.css';
import { TablaAgentes } from '../../Components/Components';
import { useParams, } from "react-router-dom";
import { SelectOficinas } from '../../Components/SelectOficinas/SelectOficinas';
import { SelectAgente,SelectTypeAgente } from '../../Components/SelectGroup/SelectGroup';
import {
  BrowserRouter as Router,
  Redirect,
  useHistory,
} from "react-router-dom";
import { AuthContext } from '../../auth/AuthContext';

export const Agentes = ({initState,updateState}) => {
  const {id} = useParams();
  let history = useHistory();
  const { usuario } = useContext(AuthContext);
  const ref = useRef(null);
  const {openMenu, data, loadingData} = initState;
  const [viewTab,setViewTab] = useState(0);
  const [isSticky, setSticky] = useState(false);
  const [selectedOficinas,setSelectedOficinas] = useState('');
  const [selectedAgentes, setSelectedAgentes] = useState('0');
  const [selectedTipos, setSelectedTipos] = useState('0');
  const [loadDataAgentes,setLoadDataAgentes] = useState(false);

  const handleScroll = () => {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrolled = winScroll / height;
    scrolled>0 ? setSticky(true) : setSticky(false) 

  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', () => handleScroll);
    };
  }, [])

  const handleChangeAgentes = (e) => {
    setLoadDataAgentes(true); 
    setSelectedAgentes(e.target.value);
  }

  const handleChangeAgentesTipos = (e) => {
    setLoadDataAgentes(true); 
    setSelectedTipos(e.target.value);
  }

  const handleChangeOficinas = (e) => {
    setLoadDataAgentes(true); 
    setSelectedOficinas(e.target.value);
  }

  const { nombre,tipo } = usuario;

  return (
    <>
      <div className={`ws_content_wrapper ${(!openMenu) ? 'wrapper_close' : ''}`}>
        <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">
  
          <Container fluid className={`ws_header_fixed ${isSticky ? 'shadow' : ''} mt-st-7`} ref={ref} style={{borderBottom:'1px solid #ccc'}}>
            <Row>
              <Col className="mb-2" xs={12} md={3}>
                <h1 className="ws_title_header">Agentes</h1>
              </Col>
              {
                (tipo!='3') && (
                  <Col className="mb-2" xs={12} md={9}>
                    <Row>
                      <SelectOficinas 
                      className="ws_select_opt"
                      value={selectedOficinas}
                      onChange={ handleChangeOficinas }
                      />
                      {/* <SelectAgente 
                      className="ws_select_opt" 
                      value={selectedAgentes} 
                      onChange={ handleChangeAgentes } 
                      /> */}
                      <SelectTypeAgente 
                      className="ws_select_opt"
                      value={selectedTipos}
                      onChange={ handleChangeAgentesTipos }
                      />
                    </Row>
                  </Col>
                )  
              }  
            </Row>
          </Container>

          <Container fluid className="mt-5">
            <Row>
              <TablaAgentes initState={initState} updateState={updateState}
                loadDataAgentes={loadDataAgentes}
                setLoadDataAgentes={setLoadDataAgentes}
                dataSelect={{
                  clave_oficina: selectedOficinas,
                  selectedAgentes,
                  selectedTipos
                }}
              />
            </Row>
          </Container>


        </div>
      </div>
    </>
  )
}
